var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 5.9092C16.429 5.90783 16.8502 6.02671 17.2155 6.25238C17.5808 6.47805 17.8756 6.80149 18.0665 7.18609L24.5662 20.1861C24.7426 20.5385 24.8259 20.9301 24.8082 21.3237C24.7906 21.7173 24.6726 22.0999 24.4655 22.4351C24.2584 22.7703 23.9691 23.047 23.6249 23.2389C23.2808 23.4308 22.8933 23.5315 22.4993 23.5314H9.49989C9.10588 23.5315 8.71841 23.4308 8.37427 23.2389C8.03014 23.047 7.74078 22.7703 7.53367 22.4351C7.32657 22.0999 7.2086 21.7173 7.19098 21.3237C7.17335 20.9301 7.25666 20.5385 7.43298 20.1861L13.9327 7.18609C14.1237 6.80149 14.4185 6.47805 14.7838 6.25238C15.1491 6.02671 15.5702 5.90783 15.9996 5.9092ZM15.9996 4.32031C15.2754 4.32023 14.5655 4.5218 13.9495 4.90244C13.3334 5.28307 12.8354 5.82774 12.5114 6.47542L6.0117 19.4754C5.71424 20.0701 5.57373 20.7309 5.60353 21.3951C5.63332 22.0593 5.83243 22.7049 6.18194 23.2705C6.53145 23.8361 7.01976 24.303 7.60047 24.6267C8.18119 24.9505 8.83503 25.1204 9.49989 25.1203H22.4993C23.1642 25.1204 23.818 24.9505 24.3988 24.6267C24.9795 24.303 25.4678 23.8361 25.8173 23.2705C26.1668 22.7049 26.3659 22.0593 26.3957 21.3951C26.4255 20.7309 26.285 20.0701 25.9875 19.4754L19.4878 6.47542C19.1638 5.82774 18.6659 5.28307 18.0498 4.90244C17.4337 4.5218 16.7238 4.32023 15.9996 4.32031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurora);
export default __webpack_public_path__ + "static/media/taurora.f59763781f1b8b8319bd913aa674719e.svg";
export { ForwardRef as ReactComponent };